var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "flex-row-space-between-hCenter home-header",
      style: {
        backgroundColor:
          _vm.scrollTop > 200 ? "rgba(255, 255, 255, 0.86)" : "transparent",
        boxShadow: _vm.scrollTop > 200 ? "0 0 10px rgba(0,0,0,0.1)" : "none",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "left",
          on: {
            click: function ($event) {
              return _vm.goHome()
            },
          },
        },
        [
          _c("img", {
            staticClass: "logo",
            attrs: { src: require("@/assets/logo.png"), alt: "" },
          }),
          _c("img", {
            staticClass: "home_title",
            attrs: { src: require("@/assets/home/home_title.png"), alt: "" },
          }),
        ]
      ),
      _c(
        "div",
        { staticClass: "right" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "default", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.onAuditProcess()
                },
              },
            },
            [_vm._v("审核进度查询")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.onLogin()
                },
              },
            },
            [_vm._v("登录")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }